import { getMessageWhatsapp } from '@helpers/helper.rendering'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import React, { useState, useEffect, Fragment } from 'react'
import { RealEstateDataPageComponentData } from 'types'
interface ExternalProps {
  developmentID?: string
  propertyID?: string
}

const isBrowser = typeof window !== 'undefined'

const cliengo_client = ({ spanText, type }: RealEstateDataPageComponentData) => {
  const [isComponentMounted, setIsComponentMounted] = useState(false)

  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  const get_cliengo_client = () => {
    if (isBrowser && isComponentMounted) {
      var ldk = document.createElement('script')
      ldk.type = 'text/javascript'
      ldk.async = true
      ldk.src =
        'https://s.cliengo.com/weboptimizer/' +
        type + // data-company-id
        '/' +
        spanText + // data-source-id
        '.js?platform=view_installation_code'
      var s: any = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(ldk, s)
    }
    return <div></div>
  }
  return isComponentMounted ? (
    <div className={'cliengo_client'}>{get_cliengo_client()}</div>
  ) : (
    <div></div>
  )
}

export default cliengo_client
